module.exports = {
    'Profile': 'Perfil',
    'File History': 'Historial del Archivo',
    'Permissions': 'Permisos',
    'Owner': 'Propietario',
    'Edit': 'Edición',
    'View': 'Ver',
    'Download': 'Descarga',
    'Share': 'Compartir',
    'Print': 'Imprimir',
    'Temporary Access': 'Acceso Temporal',
    'Temporary Print Access': 'Acceso Temporal de Impresión',
    'Message': 'Mensaje',
    'Send': 'Enviar',
    "You're done!": "Hecho!",
    "The download email has been sent. Your transfer is available.": "Los emails se han enviado. Tu transferencia está disponible.",
    'Send Another?': '¿Enviar otro?',
    "An error occurred!": "¡Ha ocurrido un error!",
    "There was an error when trying to send the file": "Ha habido un error al intentar enviar el fichero",
    "Try again": "Intentar de nuevo",
    "Load Times": 'Número de Accesos',
    'Access Until': 'Acceso hasta',
    'Days Since Access': 'Días desde el Primer Acceso',
    'Set a limit on the number of views': 'Establezca un límite en el número de visualizaciones',
    'Set a date limit': 'Establezca una fecha límite',
    'Drop files to upload': 'Suelte los ficheros para cargar',
    'Select files or drop them anywhere to upload': 'Seleccione archivos o arrástrelos aquí para subirlos',
    'Limit the number of days since first access': 'Limite el número de días des del primer acceso',
    'Limit the number of times the file can be viewn': 'Limitar el número de veces que el fichero es visto',
    'Enter the number of times a user can use the file': 'Introduzca el número de veces que se puede ver el archivo',
    'Enter number of days a user can use the file since the first access': 'Introducir el número de días que el usuario puede acceder al fichero des del primer acceso',
    'Enter the date until the user can use the file': 'Introducir la facha límite para poder acceder al fichero',
    'File Type': 'Tipo de Fichero',
    'Size': 'Tamaño',
    'Creation Date': 'Fecha de Creación',
    'Creator': 'Creador',
    'File Info': 'Información',
    'Chat': 'Chat',
    'Login': 'Entrar',
    'Register': 'Registro',
    'Sign In': 'Entrar',
    "Logout": "Salir",
    'Email': 'Email',
    'Password': 'Contraseña',
    'Username': 'Nombre',
    'Repeat Password': 'Repetir Contraseña',
    'OK': 'OK',
    'Ok': 'Ok',
    'Cancel': 'Cancelar',
    'Send email to': 'Enviar email a',
    'Your email': 'Tu email',
    'temporary.load': 'Quedan {current} de {max} visualizaciones',
    'temporary.until': 'Acceso Hasta: {date}'
};